import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { UserAuthenticationService } from '../../services/user-authentication.service';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.scss',
})
export class UnauthorizedComponent {
  constructor(
    private readonly router: Router,
    private readonly userAuthenticationService: UserAuthenticationService,
  ) {}

  goBack() {
    this.router.navigate(['/businesses']);
  }

  logout() {
    this.userAuthenticationService.logout();
  }
}
